import {Component, Input, ViewChild} from '@angular/core';
import {G2Review} from '../../../models/g2-review.model';
import {LimitedHtmlComponent} from '@app/shared/limited-html/limited-html.component';

@Component({
  selector: 'dcp-review-preview',
  templateUrl: './review-preview.component.html',
  styleUrls: ['./review-preview.component.scss']
})
export class ReviewPreviewComponent {

  @ViewChild(LimitedHtmlComponent) limitedHtmlComponent: LimitedHtmlComponent;
  @Input() review: G2Review;
  @Input() reviewAnswerOrder: string[];
  @Input() limitedHtmlSiblings: LimitedHtmlComponent[];
}
